import RequestAPI from '../index'

let protocol = window.location.protocol;
let hostname = window.location.hostname;
let port = window.location.port || (protocol === 'https:' ? '443' : '80')
let backend = `${protocol}//${hostname}:${port}`;

if (parseInt(port) === 3010) { // dev frontend
  backend = process.env.REACT_APP_API_URL || "http://192.168.1.100:3000"
}
// Adjust for .edev. subdomains
if (hostname.includes('.edev.')) {
  backend = `${protocol}//${hostname}:${port}/api`;
}

// Initialize API server
const apiServer = new RequestAPI(backend);
export default apiServer;
